<template>
  <!-- <div class="border p-2 mb-3"> -->
  <div class="p-2 mb-3">
    <b-row style="margin-left: 5px;margin-right: 5px;">
      <b-col sm="6" class="border-right">
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="libelle"><b>Libellé :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ libelle }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="code"><b>Code :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ code }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="version"><b>Version :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ version }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="date_publication_journal_officiel"><b>Date publication JO :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ date_publication_journal_officiel }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="date_debut"><b>Date début de visibilité :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ date_debut }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="date_fin"><b>Date fin de visibilité :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ date_fin }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="selectedOaps"><b>OAP :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedOaps }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="selectedOags"><b>OAG :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedOags }}</span>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="6">
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="secteur"><b>Secteur :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ secteur }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="selectedCategory"><b>Catégorie :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedCategory }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1" v-if="!isEmpty(selectedSousCategory)">
          <b-col sm="4">
            <label for="selectedSousCategory"><b>Sous-catégorie :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedSousCategory }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1" v-else>
          <b-col sm="4">
            <label for="selectedGamme"><b>Famille produit :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedGamme }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1" v-if="!isEmpty(selectedGamme) && categoryLibelleTech == 'document_prevoyance_collective'">
          <b-col sm="4">
            <label for="selectedCodeProduit"><b>Code produit :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedCodeProduit }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="selectedRubrique"><b>Rubrique :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedRubrique }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="selectedSousRubrique"><b>Sous rubrique :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedSousRubrique }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="selectedSegment"><b>Segment :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedSegment }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="selectedType"><b>Type :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedType }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="selectedGaranties"><b>Garantie :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ selectedGaranties }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="4">
            <label for="is_visible_client"><b>Visible par le client :</b></label>
          </b-col>
          <b-col sm="8">
            <span>{{ is_visible_client }}</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <strong><hr style="border:1px solid #1e8eb5"></strong>
    <b-row style="margin-left: 5px;margin-right: 5px;">
      <b-col sm="6">
        <b-row class="mb-1" v-if="!isEmpty(nom_fichier)">
          <b-col sm="4">
            <label for="nom_fichier"><b>Fichier :</b></label>
          </b-col>
          <b-col sm="8">
            <span v-if="isEmpty(nom_fichier)">Aucun fichier</span>
            <span v-else style="font-size:12px;color:#831491;cursor:pointer"><a href="#" @click.prevent="downloadDocument(selectedDocument)"><i class="fa fa-tag"></i> {{ getFileName(nom_fichier, extension) }}</a></span>
          </b-col>
        </b-row>
        <b-row class="mb-1" v-if="!isEmpty(url)">
          <b-col sm="4">
            <label for="nom_video"><b>Vidéo : </b></label>
          </b-col>
          <b-col sm="8">
            <span v-if="isEmpty(url)">Aucun vidéo</span>
            <document-video v-else :url="url"></document-video>
            <!-- <div v-else>
              <iframe :src=iframeUrl style="width:650px;height:300px" frameborder="0" allowfullscreen></iframe>
            </div> -->
            <!-- <span v-else style="font-size:12px;color:#831491;cursor:pointer"><a href="#" @click=""><i class="fa fa-tag"></i>{{ url }}</a></span> -->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { downloadMixin } from "@/mixins/downloadMixin";
  import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth';
  import { isEmpty } from "@/utils/fileHelper"
  import DocumentVideo from "@/components/Bibliotheque/Document/DocumentVideo"

  export default {
    name: 'DetailsDocument',
    mixins: [downloadMixin],
    components: {
      DocumentVideo
    },
    props: {
      selectedDocument: {
        document: Object
      }
    },
    data() {
      return {
        libelle: '',
        date_publication_journal_officiel: '',
        categoryLibelleTech: '',
        selectedCategory: '',
        selectedSousCategory: '',
        selectedType: '',
        selectedRubrique: '',
        selectedSousRubrique: '',
        selectedGaranties: '',
        selectedGamme: '',
        selectedCodeProduit: '',
        selectedSegment: '',
        code: '',
        date_debut: '',
        date_fin: '',
        selectedOaps: '',
        selectedOags: '',
        version: '',
        description: '',
        is_visible_client: '',
        nom_fichier: '',
        extension: '',
        secteur: '',
        isEmpty,
        url: '',
        // iframeUrl: ''
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl()
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken()
      this.$axios.defaults.headers.common["Accept"] = "application/json"
      this.$axios.defaults.headers.common["Provider"] = getProvider()
    },
    mounted() {
      this.initiateDocumentForm(this.selectedDocument)
    },
    methods: {
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      initiateDocumentForm(document) {
        console.log(document)
        this.libelle = document.libelle;
        this.code = document.code;
        this.version = document.version
        this.ordre = document.ordre
        this.status_id = !isEmpty(document.status) ? document.status.libelle_bo : '';
        this.date_debut = this.formatDate(document.date_debut);
        this.date_fin = this.formatDate(document.date_fin);
        this.description = document.description;
        this.selectedGaranties = !isEmpty(document.garanties) ? document.garanties.map(item => item.garantie).join(', ') : ''
        this.selectedOaps = !isEmpty(document.oaps) ? document.oaps.map(item => item.code).join(', ') : ''
        this.selectedOags = !isEmpty(document.oags) ? document.oags.map(item => item.code).join(', ') : ''
        this.nom_fichier = document.nom_fichier;
        this.extension = document.extension
        this.is_visible_client = document.is_visible_client == true ? 'Oui' : 'Non';
        this.date_publication_journal_officiel = this.formatDate(document.date_publication_journal_officiel);
        this.categoryLibelleTech = !isEmpty(document.categorie) ? document.categorie.libelle_technique : ''
        this.selectedCategory = !isEmpty(document.categorie) ? document.categorie.libelle : ''
        this.selectedSousCategory = !isEmpty(document.sous_categorie) ? document.sous_categorie.libelle : ''
        this.selectedGamme = !isEmpty(document.gamme_produit) ? document.gamme_produit.libelle : 'Général'
        this.selectedCodeProduit = !isEmpty(document.produit) ? document.produit.code_produit : ''
        this.selectedRubrique = !isEmpty(document.rubrique) ? document.rubrique.libelle : ''
        this.selectedSousRubrique = !isEmpty(document.sousRubrique) ? document.sousRubrique.libelle : ''
        this.selectedSegment = !isEmpty(document.segment) ? document.segment.libelle : ''
        this.selectedType = !isEmpty(document.type) ? document.type.libelle : ''
        this.secteur = document.secteur
        this.url = document.url
      },
      getFileName(nom_fichier, extension) {
        return nom_fichier ? nom_fichier +'.'+ extension : 'Aucun fichier'
      },
      downloadFichier(document) {
        this.$eventBus.$emit('callDownloadFichier', document)
      },

    }
  }
  </script>
